import type { IImageVariants, ILang, ILanguage } from '../store/data'

const IMAGE_VARIANT_WIDTHS = [480, 960, 1440, 1920] as const

export const buildImageSrcSet = (variants?: IImageVariants): string =>
  IMAGE_VARIANT_WIDTHS.flatMap((width) => {
    const url = variants?.[`w${width}`]
    return url ? [`${url} ${width}w`] : []
  }).join(', ')

export const selectImageSource = (
  variants: IImageVariants | undefined,
  thumbnail: string | null | undefined,
  image: string | null | undefined
): string | null => variants?.w960 ?? variants?.w480 ?? thumbnail ?? image ?? null

export const getImageFallbackUrls = (
  thumbnail: string | null | undefined,
  image: string | null | undefined
): string[] => Array.from(new Set([thumbnail, image].filter((url): url is string => !!url)))

export const resolveImageAlt = (
  alt: Partial<ILang> | undefined,
  language: ILanguage,
  fallback: string
): string => {
  const value = alt?.[language === 'cs' ? 'cs_CZ' : language]
  return value === null || value === undefined ? fallback : value
}
